// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   QuickBuySell – COMPLETE CSS (single file for Next.js)
   Page: src/ui/Pages/Order/QuickBuySell.js
   Sources:
   - src/ui/Pages/SpotOrders/spotOrders.css
   - src/ui/Pages/Order/orderMobileRowPopup.css
   - public/css-new/style.css (shell)
   - public/css-new/light_theme.css
   Bootstrap + Remix Icon NOT included.
   ========================================================= */


/* ========== SHELL (style.css + light_theme.css) ========== */

.dashboard_right {
  padding-top: 18px;
  width: 100%;
  padding-right: 30px;
  padding-bottom: 40px;
  padding-left: 30px;
}

.dashboard>.dashboard_right {
  flex: 1 1;
  min-width: 0;
  width: auto;
  max-width: 100%;
}

.Overview_mid {
  flex-direction: column;
}

.listing_left_outer.full_width {
  width: 100%;
  border: 1px solid #434343;
  border-radius: 12px;
  padding: 24px;
}

.listing_left_outer.full_width.transaction_history_t {
  margin-top: 15px;
  padding-top: 0px;
}

.full_width.transaction_history_t {
  border: none;
  padding: 12px 0px;
}

.order_history_mobile_view {
  width: 100%;
  display: none;
  margin-top: 20px;
}

.desktop_view2 {
  display: block;
}

body.light_theme .dashboard_right {
  background-color: #fff;
  color: #101828;
}

@media screen and (max-width: 1367px) {
  .desktop_view2 {
    display: none;
  }

  .order_history_mobile_view {
    display: block;
  }
}


/* ========== SPOT ORDERS (.so-*) ========== */

/* Spot Orders — main content only (.so-*), no header/sidebar */

.so-desktopWrap {
  width: 100%;
  overflow: visible;
}

.so-page {
  width: 100%;
  max-width: 100%;
  padding: 0px;
  background: #ffffff00;
  box-sizing: border-box;
  overflow: visible;
}

body.light_theme .so-page {
  background: #ffffff;
}

.so-page *,
.so-page *::before,
.so-page *::after {
  box-sizing: border-box;
}

body .so-table tbody td.first_child_td span {
  font-size: 12px;
  font-weight: 400;
  color: #8E939C;
  display: block;
}

.so-page__title {
  margin: 0 0 28px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #f0f0f0;
  line-height: 1.2;
}

body.light_theme .so-page__title {
  color: #101828;
}

/* Toolbar: filters left, download actions right (match Figma bar) */
.so-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 16px;
  margin-bottom: 0px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f0f0f038;
  -webkit-font-smoothing: antialiased;
  overflow: visible;
}

body.light_theme .so-toolbar {
  border-bottom: 1px solid #f0f0f0;
}

.so-toolbar__left {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 24px;
  flex: 0 1 auto;
  min-width: 0;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  scrollbar-width: none;
  /* Firefox */
}

.so-toolbar__left::-webkit-scrollbar {
  display: none;
  /* WebKit */
}

.so-dd__portal {
  z-index: 100000;
  /* above header + Bootstrap modals when needed */
  pointer-events: auto;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.so-dd__portal .so-dd__menu,
.so-dd__portal .so-dd__menu * {
  pointer-events: auto;
}

/* When menu is rendered in a portal, the old absolute positioning must be disabled. */
.so-dd__portal .so-dd__menu {
  position: relative;
  top: auto;
  left: -12px;
  z-index: auto;
}

.so-toolbar__right {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  margin-left: auto;
}

.so-toolbar--stack {
  flex-direction: column;
  align-items: stretch;
}

.so-toolbar--stack .so-toolbar__left,
.so-toolbar--stack .so-toolbar__right {
  width: 100%;
  justify-content: flex-start;
}

.so-toolbar--stack .so-toolbar__right {
  flex-wrap: wrap;
  margin-left: 0;
}

.so-toolbar--stack .so-dd,
.so-toolbar--stack .so-dateBlock {
  width: 100%;
  min-width: 0;
  max-width: none;
}

.so-toolbar--stack .so-dd__trigger,
.so-toolbar--stack .so-dateRow {
  width: 100%;
}

.so-toolbar--stack .so-dateRow {
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-bottom: 2px;
}

.so-toolbar--stack .so-dateRow::-webkit-scrollbar {
  display: none;
}

.so-toolbar--stack .so-dateCell {
  flex: 1 1 120px;
  min-width: 0;
  width: auto;
}

/* Custom dropdown — vertical panel + chevron (second-screen / Coin reference) */
.so-dd {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 0 0 auto;
  width: 100%;
  min-width: 192px;
  max-width: 192px;
}

.so-dd.is-open {
  z-index: 10060;
}

.so-dd__label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #ececec;
  line-height: 1.25;
  letter-spacing: 0;
  cursor: pointer;
  margin: 0;
}

body.light_theme .so-dd__label {
  color: #374151;
}

.so-dd__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  min-height: 36px;
  padding: 0 14px 0 16px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.35;
  color: #e7e7e7;
  background: #181a20;
  border: 1px solid #e9eaef26;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

body.light_theme .so-dd__trigger {
  color: #111827;
  background: #ffffff;
  border: 1px solid #E9EAEF;
}

/* .so-dd__trigger:hover {
  border-color: #c4ccd4;
} */

.so-dd__trigger:focus-visible {
  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.25);
}

.so-dd__trigger.is-open {
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.so-dd__value {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #d7d7d7;
}

body.light_theme .so-dd__value {
  color: #111827;
}

/* Muted placeholder style when used later */
.so-dd__value--placeholder {
  color: #94a3b8;
}

.so-dd__chevSvg {
  flex-shrink: 0;
  color: #4b5563;
  transition: transform 0.2s ease;
}

.so-dd__chevSvg--open {
  transform: rotate(180deg);
}

.so-dd {
  position: relative;
}

/* Open panel: horizontal tiles (reference — Contract / All + pair chips) */
.so-dd__menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 10070;
  margin: 0;
  padding: 0;
  background: #25282e;
}

body.light_theme .so-dd__menu {
  background: #ffffff;
}

.so-dd__menu--tiles {
  display: flex;
  flex-flow: row wrap;
  flex-direction: column;
  align-items: start;
  gap: 2px;
  padding: 12px;
  width: max-content;
  min-width: 100%;
  max-width: min(720px, calc(100vw - 48px));
  list-style: none;
  border: 1px solid #e0e0e026;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1), 0 2px 6px rgba(15, 23, 42, 0.06);
  overflow: visible;
}

body.light_theme .so-dd__menu--tiles {
  border: 1px solid #e0e0e0;
  background: #fff;
}

.so-dd__menu--inline {
  position: static;
  top: auto;
  left: auto;
  margin-top: 6px;
  width: 100%;
  max-width: none;
  max-height: 260px;
  overflow: auto;
}

.listing_left_outer ul li.so-dd__menuItem {
  flex: 0 0 auto;
  margin: 0;
  padding: 0;
  list-style: none;
  border: none;
  gap: 0px;
  width: 100%;
  display: block;
  border-radius: 0px;
}

.listing_left_outer ul.so-dd__menu--tiles {
  display: flex;
  margin-top: 0px;
  gap: 0px;
  padding: 0px;
  border-radius: 10px;
  overflow: hidden;
}

.listing_left_outer ul li .so-dd__option--tile {
  width: auto;
  min-width: 100%;
  justify-content: start;
  border: none;
  border-radius: 0px;
}

.so-dd__option--tile {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0px;
  width: auto;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: #d6d6d6;
  background: none;
  text-align: center;
  white-space: nowrap;
  border: none;
  border-radius: 0px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

body.light_theme .so-dd__option--tile {
  color: #1f2937;
  background: none;
}

/* .so-dd__option--tile:hover,
.so-dd__option--tile:focus-visible {
  background: #fafafa;
  outline: none;
} */

/* .so-dd__option--tile.is-selected {
  background: #f5f5f5;
  border-color: #d0d7de;
  color: #111827;
  font-weight: 600;
} */

/* Searchable dropdown — search box sits above the option list */
.so-dd__search {
  padding: 0px 2px 3px;
  border-bottom: 1px solid rgba(0, 0, 0, .07);
}

.so-dd__searchInput {
  width: 100%;
  padding: 5px 10px;
  border: 1px solid rgba(0, 0, 0, .13);
  border-radius: 6px;
  font-size: 13px;
  outline: none;
  background: transparent;
  color: inherit;
}

.so-dd__searchInput:focus {
  border-color: var(--color-primary, #f0b90b);
}

.so-dd__noResults {
  padding: 10px 14px;
  font-size: 13px;
  color: #94a3b8;
  list-style: none;
}

/* Date range — visible text matches design; native picker overlay */
.so-dateBlock {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 0 0 auto;
  min-width: 0;
}

.so-dateBlock__label {
  font-size: 14px;
  font-weight: 500;
  color: #ececec;
  line-height: 1.2;
}

body.light_theme .so-dateBlock__label {
  color: #101828;
}

.so-dateRow {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
}

.so-dateArrow {
  flex-shrink: 0;
  font-size: 13px;
  color: #9ca3af;
  -webkit-user-select: none;
          user-select: none;
  line-height: 1;
}

.so-dateCell {
  position: relative;
  flex: 0 0 auto;
  width: 132px;
  height: 36px;
  color: #e7e7e7;
  background: #181a20;
  border: 1px solid #e9eaef26;
  border-radius: 4px;
}

body.light_theme .so-dateCell {
  background: #ffffff;
  border: 1px solid #e0e0e0;
}

/* .so-dateCell:hover {
  border-color: #d4d4d4;
}

.so-dateCell:focus-within {
  border-color: #bdbdbd;
} */

.so-dateCell__text {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 400;
  color: #cfcfcf;
  pointer-events: none;
}

body.light_theme .so-dateCell__text {
  color: #1f2937;
}

.so-dateCell__native {
  position: absolute;
  inset: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  margin: 0;
  min-height: 36px;
  padding: 0;
  font-size: 16px;
  line-height: 40px;
  color: transparent;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0;
}

.so-dateCell__native::-webkit-calendar-picker-indicator {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: pointer;
  opacity: 0;
}

.so-dateCalBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 36px;
  padding: 0;
  flex-shrink: 0;
  color: #dddddd;
  background: #181a20;
  border: 1px solid #e0e0e02e;
  border-radius: 4px;
  cursor: pointer;
}

body.light_theme .so-dateCalBtn {
  color: #6b7280;
  background: #ffffff;
  border: 1px solid #e0e0e0;
}

/* .so-dateCalBtn:hover {
  color: #374151;
} */

/* Download / batch download */
.so-dlBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  background: #ededed2e;
  border: 1px solid #e9eaef14;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
}

.so-dlBtn img {
  filter: invert(1);
}

body.light_theme .so-dlBtn img {
  filter: invert(0);
}

body.light_theme .so-dlBtn {
  color: #1f2937;
  background: #ffffff;
  border: 1px solid #E9EAEF;
}

.so-dlBtn:hover {
  opacity: 0.85;
}

.so-dlBtn__icon {
  flex-shrink: 0;
  color: #6b7280;
}

.so-tableWrap {
  width: 100%;
  min-height: 400px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 0;
}

.so-table {
  width: 100%;
  min-width: 1080px;
  border-collapse: collapse;
  font-size: 14px;
  font-weight: 500;
  color: #f0f0f0;
}

body.light_theme .so-table {
  color: #101828;
}

body .quickbuytable .so-table thead th {
  padding: 12px 14px 14px;
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  color: #98a2b3;
  letter-spacing: 0.02em;
  text-transform: none;
  border-bottom: 1px solid #eef2f63b;
  white-space: nowrap;
}

body.light_theme .so-table thead th {
  border-bottom: 1px solid #eef2f6;
}

.so-table thead th.so-table__th--right,
.so-table tbody td.so-table__td--right {
  text-align: right;
}

.so-table thead th.so-table__th--center,
.so-table tbody td.so-table__td--center {
  text-align: center;
}

body .so-table tbody td {
  padding: 14px;
  /* border-bottom: 1px solid #f2f4f7; */
  vertical-align: middle;
  color: #ebebeb;
  font-size: 14px;
  font-weight: 400;
}

body.light_theme .so-table tbody td {
  color: #101828;
}

.so-table tbody tr:last-child td {
  border-bottom: none;
}

/* Wider futures / open-orders grid; airy row spacing (screenshot-style) */
.so-table.so-table--air {
  min-width: 1280px;
}

.so-table.so-table--air tbody td {
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: none;
}

.so-table.so-table--air tbody tr+tr td {
  box-shadow: none
}

/* .so-table.so-table--air .so-side--buy,
.so-table.so-table--air .so-side--sell {
  background: transparent;
  padding: 0;
  border-radius: 0;
  font-weight: 600;
} */

.so-table.so-table--air .so-side--buy {
  color: #008236;
}

.so-table.so-table--air .so-side--sell {
  color: #e7000b;
}


/* Position status e.g. Closed */
.so-badge--closed {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  border-radius: 999px;
  font-size: 16px;
}

.so-status {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}

.so-status--completed {
  color: #008236;
  font-weight: 400;
  /* background-color: #F0FDF4; */
  font-size: 16px;
  /* min-width: 85px; */
  padding: 0px 0px;
  border-radius: 0px;
}

.so-fillQty--pos {
  color: #16A34A;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.amountgreen {
  color: #008236;
}

.so-badge-processing {
  color: #1E40AF;
  font-weight: 500;
  background-color: #DBEAFE;
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 50px;
}

.so-table.so-table--air tbody td .bankbtn {
  font-size: 11px;
  font-weight: 400;
  background-color: #F3F4F6;
  border-radius: 4px;
  display: inline-block;
  padding: 4px 7px;
}

table tbody tr td span.so-badge-crypto {
  color: #8200DB;
  font-weight: 500;
  font-size: 12px;
  background-color: #F3E8FF;
  border: 1px solid #E9D4FF;
  padding: 3px 7px;
  border-radius: 50px;
}

.so-table.so-table--air tbody td strong {
  font-weight: 500;
}

.so-side--buy {
  color: #16A34A;
  font-weight: 400;
  /* background-color: #F0FDF4; */
  padding: 0px 0px;
  border-radius: 50px;
  font-size: 14px;
}

.so-side--sell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  border: none;
  border-radius: 999px;
  font-size: 14px;
  /* font-weight: 500; */
  color: #E7000B;
  /* background: #FEF2F2; */
  cursor: pointer;
}

.so-num {
  font-variant-numeric: tabular-nums;
}

/* Mobile — visibility toggled by global .order_history_mobile_view / .desktop_view2 in style.css */
.so-mobile {
  padding: 0px;
}

.so-mobile__title {
  margin: 0 0 20px;
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

body.light_theme .so-mobile__title {
  color: #101828;
}

.so-mobile__toolbar {
  margin: 10px 0px;
}

.so-subtabsWrap {
  position: relative;
}

.so-subtabs {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 10px 0 0;
  margin: 0 0 14px;
  border-bottom: none;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.so-subtabs::-webkit-scrollbar {
  display: none;
}

.so-subtabs__tab {
  position: relative;
  padding: 10px 0 7px;
  font-size: 16px;
  font-weight: 500;
  color: #b5b5b6 !important;
  text-decoration: none;
  white-space: nowrap;
}


body.light_theme .so-subtabs__tab {
  color: #667085 !important;
}

.so-subtabs__tab:hover {
  color: #f1f1f1;
}

body.light_theme .so-subtabs__tab:hover {
  color: #101828 !important;
}

.so-subtabs__tab.is-active {
  color: #f1f1f1 !important;
}

body.light_theme .so-subtabs__tab.is-active {
  color: #101828 !important;
}

.so-subtabs__tab.is-active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  right: 0px;
  width: 18px;
  height: 4px;
  background: #d1aa67;
  border-radius: 0px;
  margin: 0 auto;
}

/* Subtabs scroll arrows (mobile only) */
.so-subtabsArrow {
  display: none;
}

.so-mobileFiltersBar {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.so-filterIconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0px;
  padding: 0px;
  border: none;
  background: none;
  color: #f7f7f7;
}

body.light_theme .so-filterIconBtn {
  color: #101828;
}

.so-filterIconBtn i {
  font-size: 20px;
}

.so-filtersModal .modal-body .so-toolbar {
  margin: 0;
}

.so-filtersModal--filters .so-toolbar__right {
  display: none !important;
}

.so-filtersModal .modal-body .so-toolbar__left {
  width: 100%;
}

.so-filtersModal .modal-body .so-dlBtn {
  width: 100%;
  justify-content: center;
}

.so-filtersModal__footer {
  display: flex;
  gap: 10px;
}

.so-filtersModal__footer .btn {
  flex: 1 1;
}

body.light_theme .so-filtersModal .modal-content {
  background: rgb(255 255 255 / 20%);
  color: #101828;
}

.so-filtersModal .modal-content {
  background: #1e232985;
  color: #eaecef;
}

body.light_theme .so-filtersModal .modal-header {
  border-bottom-color: #eef2f6;
}

.so-filtersModal .modal-header {
  border-bottom-color: #2b3139;
}

body.light_theme .so-filtersModal .modal-title {
  color: #101828;
}

.so-filtersModal .modal-title {
  color: #eaecef;
}

.so-mobileCard {
  margin-bottom: 24px;
}

.so-mobileCard__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 5px 0;
  font-size: 16px;
  color: #000;
}

.so-mobileCard__row span:first-child {
  color: #000000;
  font-weight: 400;
}

.so-mobileCard__row span:last-child {
  text-align: right;
}

.so-mobileCard__actions {
  margin-top: 0px;
  padding-top: 0px;
  text-align: center;
}

.so-emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 400px;
  padding: 16px 0;
}

.so-emptyState--mobile {
  min-height: 400px;
  margin-top: 8px;
  padding: 32px 16px 48px;
  border-radius: 12px;
}

.so-emptyState__img {
  display: block;
  width: 120px;
  height: auto;
  max-height: 160px;
  object-fit: contain;
  filter: invert(1);
}

body.light_theme .so-emptyState__img {
  filter: invert(0);
}

.so-emptyState__caption {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #98a2b3;
}

@media (max-width: 1440px) {

  .so-toolbar .so-toolbar__left {
    width: 70%;
    overflow: scroll;
  }

  .listing_left_outer.full_width.transaction_history_t .so-contractCell__symbol {
    font-size: 12px;
  }

  .listing_left_outer.full_width.transaction_history_t .so-contractCell__time {
    font-size: 12px;
  }

  body .so-table tbody td {
    padding: 10px;
    font-size: 12px;
  }

  .so-side--buy {
    font-size: 12px;
  }

  .so-side--sell {
    font-size: 12px;
  }

  .so-toolbar__left.fullwidthdesktop {
    width: 100%;
  }

}


@media (max-width: 1367px) {

  .so-dateCell__text {
    font-size: 12px;
  }

  .so-dd__trigger {
    font-size: 12px;
  }

  .so-dateBlock__label {
    font-size: 12px;
  }

  .so-dd__label {
    font-size: 12px;
  }

  .so-toolbar__left {
    gap: 15px;
  }

  .so-badge--closed {
    font-size: 12px;
  }

}

@media (max-width: 1200px) {

  .so-toolbar--stack .so-toolbar__left,
  .so-toolbar--stack .so-toolbar__right {
    flex-wrap: wrap;
  }

  body .so-table tbody td {
    font-size: 12px;
  }

  .so-toolbar__left {
    gap: 12px;
  }

  .so-toolbar .so-toolbar__left {
    width: 100%;
  }

}

@media (max-width: 991px) {

  .so-mobile__title {
    display: none;
  }

  .orders-mrp__panel.orders-mrp__panel--light .so-mobileCard__statusLabel {
    font-size: 14px;
    color: #707a8a;
  }

  .orders-mrp__panel.orders-mrp__panel--light .so-cancelBtn {
    font-size: 14px;
  }

  .so-mobile .so-subtabs {
    padding: 0px 0 0;
    margin: 0 0 10px;
    border-bottom: none;
  }

  .so-mobile .so-subtabsWrap {
    padding: 0px;
    /* room for arrows */
  }

  .so-dd__menu--inline {
    position: absolute;
    top: 64px;
  }

  .so-mobile .so-subtabsArrow {
    display: inline-flex;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    align-items: center;
    justify-content: center;
    padding: 0px;
    height: 24px;
    border: none;
    border-radius: 0px !important;
    background: none;
    color: #ffffff;
    border-radius: 999px;
  }

  body.light_theme .so-mobile .so-subtabsArrow {
    background: #fff;
    color: #101828;
  }

  .so-mobile .so-subtabsArrow i {
    font-size: 18px;
    line-height: 1;
  }

  .so-mobile .so-subtabsArrow--left {
    left: -17px;
  }

  .so-mobile .so-subtabsArrow--right {
    right: -17px;
  }

  .so-mobile .so-subtabsArrow.is-hidden {
    display: none;
  }

  .so-mobile {
    margin-top: -12px;
  }

  .so-dd__menu--inline {
    margin-top: 0px;
  }

}

@media (max-width: 640px) {
  .so-page {
    padding: 20px 16px 32px;
  }

  .so-page__title {
    font-size: 26px;
  }

  .so-toolbar:not(.so-toolbar--stack) {
    flex-direction: column;
    align-items: stretch;
  }

  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__left,
  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__right {
    width: 100%;
  }

  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__right {
    justify-content: flex-start;
  }

  .so-dd,
  .so-dateBlock {
    width: 100%;
    min-width: 0;
  }

  .so-subtabs__tab {
    font-size: 15px;
  }

  .so-dd__trigger {
    width: 100%;
    min-width: 0;
  }

  .so-toolbar--stack .so-goStakingBtn {
    width: 100%;
    justify-content: center;
  }
}

/*
 * Profile \`/user_profile/orders/spot_*\`: global style.css switches table vs cards at 1367px
 * viewport, while the profile rail uses 992px — narrow desktop can hide both or show the wrong
 * column. Force open-orders / order-history / trade-history mobile cards at ≤991px so the
 * same React \`rows\` as the table are visible on phones.
 */
@media (max-width: 991.98px) {
  .dashboard_right .dashboard_listing_section2.Overview_mid .listing_left_outer.full_width.transaction_history_t.desktop_view2.so-desktopWrap {
    display: none !important;
  }

  .dashboard_right .dashboard_listing_section2.Overview_mid .order_history_mobile_view.so-mobile {
    display: block !important;
    width: 100%;
  }
}


/* ========== MOBILE ROW POPUP (orderMobileRowPopup.css) ========== */

/* Shared mobile row popup — popup when table has more than 6 columns / field rows; ≤6 no popup */

.orders-mrp-card {
  overflow: hidden;
}

/* Mobile order cards — white panel, pair + side/type hero, KV rows */
.orders-mobCard {
  color: #f0f0f0;
  border-radius: 0px;
  overflow: hidden;
  margin-bottom: 12px;
  box-shadow: none;
  padding: 0px;
}

body.light_theme .orders-mobCard {
  color: #1e2329;
}

.so-mobileCard {
  /* border-bottom: 1px solid #efefef;
  padding-bottom: 8px; */
}

.orders-mobCard__hero {
  padding: 5px 0 0px;
  /* border-bottom: 1px solid #f0f2f5; */
  margin-bottom: 2px;
}

.orders-mobCard__pairLine {
  display: flex;
  align-items: center;
  gap: 4px;
}

.orders-mobCard__pair {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  letter-spacing: -0.02em;
}

body.light_theme .orders-mobCard__pair {
  color: #0b0e11;
}

.orders-mobCard__chev {
  font-size: 18px;
  color: #b7bdc6;
  font-weight: 400;
  line-height: 1;
}

.orders-mobCard__datetime {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.35;
  color: #707a8a;
}

.orders-mobCard__subtypeRow {
  margin-top: 2px;
}

.orders-mobCard__subtype {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.35;
}

.orders-mobCard__subtype--buy {
  color: #0ecb81;
}

.orders-mobCard__subtype--sell {
  color: #f6465d;
}

.orders-mobCard__body--plain .so-mobileCard__row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 5px 0;
  font-size: 13px;
  border-bottom: none;
}

ul.so-dd__menu.so-dd__menu--tiles {
  left: 0px;
}

.orders-mobCard__body--plain .so-mobileCard__row span:first-child {
  color: #adb0b5;
  font-weight: 400;
  flex-shrink: 0;
}

body.light_theme .orders-mobCard__body--plain .so-mobileCard__row span:first-child {
  color: #707a8a;
}

.orders-mobCard__body--plain .so-mobileCard__row span:last-child {
  text-align: right;
  color: #e5e5e5;
  flex-direction: row;
}

body.light_theme .orders-mobCard__body--plain .so-mobileCard__row span:last-child {
  color: #1e2329;
}

/* Tap hero + preview rows to open full detail sheet (when 7+ cols & 7+ rows). */
.orders-mobCard__tapZone {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.orders-mobCard__tapZone:focus-visible {
  outline: 2px solid #f0b90b;
  outline-offset: 2px;
  border-radius: 8px;
}

.orders-mobCard__statusVal {
  color: #98a2b3 !important;
}

.orders-mobCard .so-mobileCard__actions {
  margin-top: 0px;
  padding-top: 2px;
}

.orders-mrp {
  position: fixed;
  inset: 0;
  z-index: 999999999;
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 0px;
  /* border-radius: 0px; */
  padding-bottom: 0px;
  box-sizing: border-box;
}

.orders-mrp__backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.45);
  -webkit-tap-highlight-color: transparent;
}

.orders-mrp__panel {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 100%;
  min-height: 100%;
  max-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  animation: orders-mrp-pop 0.2s ease-out;
}

.orders-mrp__panel--light {
  background: #000000;
  color: #ebebeb;
}

body.light_theme .orders-mrp__panel--light {
  background: #ffffff;
  color: #1e2329;
}

@keyframes orders-mrp-pop {
  from {
    transform: scale(0.96);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.orders-mrp__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 16px 16px 5px;
}

.orders-mrp__title {
  font-size: 17px;
  font-weight: 600;
  padding-right: 8px;
}

.orders-mrp__close {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  -webkit-tap-highlight-color: transparent;
}

.orders-mrp__close::before,
.orders-mrp__close::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 20px;
  height: 2px;
  background: #ebebeb;
  border-radius: 1px;
}

body.light_theme .orders-mrp__close::before,
body.light_theme .orders-mrp__close::after {
  background: #454647;
}

.orders-mrp__close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.orders-mrp__close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.orders-mrp__body {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.orders-mrp__detailInner {
  padding: 8px 16px 4px;
}

/* Light modal: hero + rows match card */
.orders-mrp__panel--light .orders-mrp__detailInner .orders-mobCard__hero {
  padding-top: 4px;
}

.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row {
  border-color: transparent;
  font-size: 14px;
}

.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:first-child {
  color: #707a8a;
}

.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:last-child {
  color: #e0e0e0;
}

body.light_theme .orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:last-child {
  color: #1e2329;
}

.orders-mrp__actionsSlot {
  padding: 0px 16px 0px;
}

.orders-mrp__actionsSlot .so-mobileCard__actions {
  margin: 0;
}

.orders-mrp__footer {
  flex-shrink: 0;
  margin-top: auto;
  padding: 16px 16px 12px;
  padding-bottom: max(16px, env(safe-area-inset-bottom));
  background: #000000;
}

body.light_theme .orders-mrp__footer {
  background: #ffffff;
}

.orders-mrp__ok {
  display: block;
  width: 100%;
  padding: 11px 16px;
  margin: 0;
  border: none;
  border-radius: 50px;
  background: #111827;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.orders-mrp__ok:focus-visible {
  outline: 2px solid #1e2329;
  outline-offset: 2px;
}

.orders-mrp__ok:active {
  filter: brightness(0.95);
}


ul.so-dd__menu.so-dd__menu--tiles {
  flex-wrap: nowrap;
}


@media screen and (max-width: 767px) {

  .orders-mrp__ok {
    padding: 9px 16px;
    font-size: 12px;
  }

  .so-status--completed {
    font-size: 14px;
  }


  .so-subtabs__tab {
    font-size: 14px;
  }

}

@media screen and (max-width: 480px) {

  .so-dateCell {
    width: 100px;
  }

  .so-status--completed {
    font-size: 13px;
  }

  .orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row {
    font-size: 13px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Order/QuickBuySell.css"],"names":[],"mappings":"AAAA;;;;;;;;;8DAS8D;;;AAG9D,8DAA8D;;AAE9D;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,SAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;;AAGA,8CAA8C;;AAE9C,+DAA+D;;AAE/D;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,8BAA8B;EAC9B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA,sFAAsF;AACtF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,cAAc;EACd,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,8EAA8E;EAC9E,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;GAIG;;AAEH;;;;;GAKG;;AAEH,gEAAgE;AAChE;EACE,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;;GAMG;;AAEH;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;;;;;;GAMG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,mGAAmG;AACnG;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;AAEF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;AAEF;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;;;;;EAKE;AACF;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;AACF;;;AAGA,qEAAqE;;AAErE,iGAAiG;;AAEjG;EACE,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;wBACsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,SAAW;EACX,aAAa;EACb,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,iBAAiB;AACnB;;;AAGA;;EAEE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* =========================================================\n   QuickBuySell – COMPLETE CSS (single file for Next.js)\n   Page: src/ui/Pages/Order/QuickBuySell.js\n   Sources:\n   - src/ui/Pages/SpotOrders/spotOrders.css\n   - src/ui/Pages/Order/orderMobileRowPopup.css\n   - public/css-new/style.css (shell)\n   - public/css-new/light_theme.css\n   Bootstrap + Remix Icon NOT included.\n   ========================================================= */\n\n\n/* ========== SHELL (style.css + light_theme.css) ========== */\n\n.dashboard_right {\n  padding-top: 18px;\n  width: 100%;\n  padding-right: 30px;\n  padding-bottom: 40px;\n  padding-left: 30px;\n}\n\n.dashboard>.dashboard_right {\n  flex: 1 1 0%;\n  min-width: 0;\n  width: auto;\n  max-width: 100%;\n}\n\n.Overview_mid {\n  flex-direction: column;\n}\n\n.listing_left_outer.full_width {\n  width: 100%;\n  border: 1px solid #434343;\n  border-radius: 12px;\n  padding: 24px;\n}\n\n.listing_left_outer.full_width.transaction_history_t {\n  margin-top: 15px;\n  padding-top: 0px;\n}\n\n.full_width.transaction_history_t {\n  border: none;\n  padding: 12px 0px;\n}\n\n.order_history_mobile_view {\n  width: 100%;\n  display: none;\n  margin-top: 20px;\n}\n\n.desktop_view2 {\n  display: block;\n}\n\nbody.light_theme .dashboard_right {\n  background-color: #fff;\n  color: #101828;\n}\n\n@media screen and (max-width: 1367px) {\n  .desktop_view2 {\n    display: none;\n  }\n\n  .order_history_mobile_view {\n    display: block;\n  }\n}\n\n\n/* ========== SPOT ORDERS (.so-*) ========== */\n\n/* Spot Orders — main content only (.so-*), no header/sidebar */\n\n.so-desktopWrap {\n  width: 100%;\n  overflow: visible;\n}\n\n.so-page {\n  width: 100%;\n  max-width: 100%;\n  padding: 0px;\n  background: #ffffff00;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\nbody.light_theme .so-page {\n  background: #ffffff;\n}\n\n.so-page *,\n.so-page *::before,\n.so-page *::after {\n  box-sizing: border-box;\n}\n\nbody .so-table tbody td.first_child_td span {\n  font-size: 12px;\n  font-weight: 400;\n  color: #8E939C;\n  display: block;\n}\n\n.so-page__title {\n  margin: 0 0 28px;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #f0f0f0;\n  line-height: 1.2;\n}\n\nbody.light_theme .so-page__title {\n  color: #101828;\n}\n\n/* Toolbar: filters left, download actions right (match Figma bar) */\n.so-toolbar {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-end;\n  justify-content: flex-start;\n  gap: 16px;\n  margin-bottom: 0px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #f0f0f038;\n  -webkit-font-smoothing: antialiased;\n  overflow: visible;\n}\n\nbody.light_theme .so-toolbar {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.so-toolbar__left {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 24px;\n  flex: 0 1 auto;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: visible;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-x: contain;\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n.so-toolbar__left::-webkit-scrollbar {\n  display: none;\n  /* WebKit */\n}\n\n.so-dd__portal {\n  z-index: 100000;\n  /* above header + Bootstrap modals when needed */\n  pointer-events: auto;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.so-dd__portal .so-dd__menu,\n.so-dd__portal .so-dd__menu * {\n  pointer-events: auto;\n}\n\n/* When menu is rendered in a portal, the old absolute positioning must be disabled. */\n.so-dd__portal .so-dd__menu {\n  position: relative;\n  top: auto;\n  left: -12px;\n  z-index: auto;\n}\n\n.so-toolbar__right {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.so-toolbar--stack {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.so-toolbar--stack .so-toolbar__left,\n.so-toolbar--stack .so-toolbar__right {\n  width: 100%;\n  justify-content: flex-start;\n}\n\n.so-toolbar--stack .so-toolbar__right {\n  flex-wrap: wrap;\n  margin-left: 0;\n}\n\n.so-toolbar--stack .so-dd,\n.so-toolbar--stack .so-dateBlock {\n  width: 100%;\n  min-width: 0;\n  max-width: none;\n}\n\n.so-toolbar--stack .so-dd__trigger,\n.so-toolbar--stack .so-dateRow {\n  width: 100%;\n}\n\n.so-toolbar--stack .so-dateRow {\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding-bottom: 2px;\n}\n\n.so-toolbar--stack .so-dateRow::-webkit-scrollbar {\n  display: none;\n}\n\n.so-toolbar--stack .so-dateCell {\n  flex: 1 1 120px;\n  min-width: 0;\n  width: auto;\n}\n\n/* Custom dropdown — vertical panel + chevron (second-screen / Coin reference) */\n.so-dd {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 0 0 auto;\n  width: 100%;\n  min-width: 192px;\n  max-width: 192px;\n}\n\n.so-dd.is-open {\n  z-index: 10060;\n}\n\n.so-dd__label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ececec;\n  line-height: 1.25;\n  letter-spacing: 0;\n  cursor: pointer;\n  margin: 0;\n}\n\nbody.light_theme .so-dd__label {\n  color: #374151;\n}\n\n.so-dd__trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  min-height: 36px;\n  padding: 0 14px 0 16px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.35;\n  color: #e7e7e7;\n  background: #181a20;\n  border: 1px solid #e9eaef26;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: left;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\nbody.light_theme .so-dd__trigger {\n  color: #111827;\n  background: #ffffff;\n  border: 1px solid #E9EAEF;\n}\n\n/* .so-dd__trigger:hover {\n  border-color: #c4ccd4;\n} */\n\n.so-dd__trigger:focus-visible {\n  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.25);\n}\n\n.so-dd__trigger.is-open {\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.so-dd__value {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #d7d7d7;\n}\n\nbody.light_theme .so-dd__value {\n  color: #111827;\n}\n\n/* Muted placeholder style when used later */\n.so-dd__value--placeholder {\n  color: #94a3b8;\n}\n\n.so-dd__chevSvg {\n  flex-shrink: 0;\n  color: #4b5563;\n  transition: transform 0.2s ease;\n}\n\n.so-dd__chevSvg--open {\n  transform: rotate(180deg);\n}\n\n.so-dd {\n  position: relative;\n}\n\n/* Open panel: horizontal tiles (reference — Contract / All + pair chips) */\n.so-dd__menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  z-index: 10070;\n  margin: 0;\n  padding: 0;\n  background: #25282e;\n}\n\nbody.light_theme .so-dd__menu {\n  background: #ffffff;\n}\n\n.so-dd__menu--tiles {\n  display: flex;\n  flex-flow: row wrap;\n  flex-direction: column;\n  align-items: start;\n  gap: 2px;\n  padding: 12px;\n  width: max-content;\n  min-width: 100%;\n  max-width: min(720px, calc(100vw - 48px));\n  list-style: none;\n  border: 1px solid #e0e0e026;\n  border-radius: 10px;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1), 0 2px 6px rgba(15, 23, 42, 0.06);\n  overflow: visible;\n}\n\nbody.light_theme .so-dd__menu--tiles {\n  border: 1px solid #e0e0e0;\n  background: #fff;\n}\n\n.so-dd__menu--inline {\n  position: static;\n  top: auto;\n  left: auto;\n  margin-top: 6px;\n  width: 100%;\n  max-width: none;\n  max-height: 260px;\n  overflow: auto;\n}\n\n.listing_left_outer ul li.so-dd__menuItem {\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border: none;\n  gap: 0px;\n  width: 100%;\n  display: block;\n  border-radius: 0px;\n}\n\n.listing_left_outer ul.so-dd__menu--tiles {\n  display: flex;\n  margin-top: 0px;\n  gap: 0px;\n  padding: 0px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.listing_left_outer ul li .so-dd__option--tile {\n  width: auto;\n  min-width: 100%;\n  justify-content: start;\n  border: none;\n  border-radius: 0px;\n}\n\n.so-dd__option--tile {\n  display: inline-flex;\n  align-items: center;\n  min-height: 32px;\n  padding: 0px;\n  width: auto;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.2;\n  color: #d6d6d6;\n  background: none;\n  text-align: center;\n  white-space: nowrap;\n  border: none;\n  border-radius: 0px;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\nbody.light_theme .so-dd__option--tile {\n  color: #1f2937;\n  background: none;\n}\n\n/* .so-dd__option--tile:hover,\n.so-dd__option--tile:focus-visible {\n  background: #fafafa;\n  outline: none;\n} */\n\n/* .so-dd__option--tile.is-selected {\n  background: #f5f5f5;\n  border-color: #d0d7de;\n  color: #111827;\n  font-weight: 600;\n} */\n\n/* Searchable dropdown — search box sits above the option list */\n.so-dd__search {\n  padding: 0px 2px 3px;\n  border-bottom: 1px solid rgba(0, 0, 0, .07);\n}\n\n.so-dd__searchInput {\n  width: 100%;\n  padding: 5px 10px;\n  border: 1px solid rgba(0, 0, 0, .13);\n  border-radius: 6px;\n  font-size: 13px;\n  outline: none;\n  background: transparent;\n  color: inherit;\n}\n\n.so-dd__searchInput:focus {\n  border-color: var(--color-primary, #f0b90b);\n}\n\n.so-dd__noResults {\n  padding: 10px 14px;\n  font-size: 13px;\n  color: #94a3b8;\n  list-style: none;\n}\n\n/* Date range — visible text matches design; native picker overlay */\n.so-dateBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 0 0 auto;\n  min-width: 0;\n}\n\n.so-dateBlock__label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #ececec;\n  line-height: 1.2;\n}\n\nbody.light_theme .so-dateBlock__label {\n  color: #101828;\n}\n\n.so-dateRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 8px;\n}\n\n.so-dateArrow {\n  flex-shrink: 0;\n  font-size: 13px;\n  color: #9ca3af;\n  user-select: none;\n  line-height: 1;\n}\n\n.so-dateCell {\n  position: relative;\n  flex: 0 0 auto;\n  width: 132px;\n  height: 36px;\n  color: #e7e7e7;\n  background: #181a20;\n  border: 1px solid #e9eaef26;\n  border-radius: 4px;\n}\n\nbody.light_theme .so-dateCell {\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n}\n\n/* .so-dateCell:hover {\n  border-color: #d4d4d4;\n}\n\n.so-dateCell:focus-within {\n  border-color: #bdbdbd;\n} */\n\n.so-dateCell__text {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #cfcfcf;\n  pointer-events: none;\n}\n\nbody.light_theme .so-dateCell__text {\n  color: #1f2937;\n}\n\n.so-dateCell__native {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  min-height: 36px;\n  padding: 0;\n  font-size: 16px;\n  line-height: 40px;\n  color: transparent;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  opacity: 0;\n}\n\n.so-dateCell__native::-webkit-calendar-picker-indicator {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0;\n}\n\n.so-dateCalBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 36px;\n  padding: 0;\n  flex-shrink: 0;\n  color: #dddddd;\n  background: #181a20;\n  border: 1px solid #e0e0e02e;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\nbody.light_theme .so-dateCalBtn {\n  color: #6b7280;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n}\n\n/* .so-dateCalBtn:hover {\n  color: #374151;\n} */\n\n/* Download / batch download */\n.so-dlBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 14px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  color: #ffffff;\n  background: #ededed2e;\n  border: 1px solid #e9eaef14;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.so-dlBtn img {\n  filter: invert(1);\n}\n\nbody.light_theme .so-dlBtn img {\n  filter: invert(0);\n}\n\nbody.light_theme .so-dlBtn {\n  color: #1f2937;\n  background: #ffffff;\n  border: 1px solid #E9EAEF;\n}\n\n.so-dlBtn:hover {\n  opacity: 0.85;\n}\n\n.so-dlBtn__icon {\n  flex-shrink: 0;\n  color: #6b7280;\n}\n\n.so-tableWrap {\n  width: 100%;\n  min-height: 400px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 0;\n}\n\n.so-table {\n  width: 100%;\n  min-width: 1080px;\n  border-collapse: collapse;\n  font-size: 14px;\n  font-weight: 500;\n  color: #f0f0f0;\n}\n\nbody.light_theme .so-table {\n  color: #101828;\n}\n\nbody .quickbuytable .so-table thead th {\n  padding: 12px 14px 14px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 500;\n  color: #98a2b3;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  border-bottom: 1px solid #eef2f63b;\n  white-space: nowrap;\n}\n\nbody.light_theme .so-table thead th {\n  border-bottom: 1px solid #eef2f6;\n}\n\n.so-table thead th.so-table__th--right,\n.so-table tbody td.so-table__td--right {\n  text-align: right;\n}\n\n.so-table thead th.so-table__th--center,\n.so-table tbody td.so-table__td--center {\n  text-align: center;\n}\n\nbody .so-table tbody td {\n  padding: 14px;\n  /* border-bottom: 1px solid #f2f4f7; */\n  vertical-align: middle;\n  color: #ebebeb;\n  font-size: 14px;\n  font-weight: 400;\n}\n\nbody.light_theme .so-table tbody td {\n  color: #101828;\n}\n\n.so-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Wider futures / open-orders grid; airy row spacing (screenshot-style) */\n.so-table.so-table--air {\n  min-width: 1280px;\n}\n\n.so-table.so-table--air tbody td {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  border-bottom: none;\n}\n\n.so-table.so-table--air tbody tr+tr td {\n  box-shadow: none\n}\n\n/* .so-table.so-table--air .so-side--buy,\n.so-table.so-table--air .so-side--sell {\n  background: transparent;\n  padding: 0;\n  border-radius: 0;\n  font-weight: 600;\n} */\n\n.so-table.so-table--air .so-side--buy {\n  color: #008236;\n}\n\n.so-table.so-table--air .so-side--sell {\n  color: #e7000b;\n}\n\n\n/* Position status e.g. Closed */\n.so-badge--closed {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  border-radius: 999px;\n  font-size: 16px;\n}\n\n.so-status {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.so-status--completed {\n  color: #008236;\n  font-weight: 400;\n  /* background-color: #F0FDF4; */\n  font-size: 16px;\n  /* min-width: 85px; */\n  padding: 0px 0px;\n  border-radius: 0px;\n}\n\n.so-fillQty--pos {\n  color: #16A34A;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n}\n\n.amountgreen {\n  color: #008236;\n}\n\n.so-badge-processing {\n  color: #1E40AF;\n  font-weight: 500;\n  background-color: #DBEAFE;\n  font-size: 12px;\n  padding: 3px 10px;\n  border-radius: 50px;\n}\n\n.so-table.so-table--air tbody td .bankbtn {\n  font-size: 11px;\n  font-weight: 400;\n  background-color: #F3F4F6;\n  border-radius: 4px;\n  display: inline-block;\n  padding: 4px 7px;\n}\n\ntable tbody tr td span.so-badge-crypto {\n  color: #8200DB;\n  font-weight: 500;\n  font-size: 12px;\n  background-color: #F3E8FF;\n  border: 1px solid #E9D4FF;\n  padding: 3px 7px;\n  border-radius: 50px;\n}\n\n.so-table.so-table--air tbody td strong {\n  font-weight: 500;\n}\n\n.so-side--buy {\n  color: #16A34A;\n  font-weight: 400;\n  /* background-color: #F0FDF4; */\n  padding: 0px 0px;\n  border-radius: 50px;\n  font-size: 14px;\n}\n\n.so-side--sell {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  border: none;\n  border-radius: 999px;\n  font-size: 14px;\n  /* font-weight: 500; */\n  color: #E7000B;\n  /* background: #FEF2F2; */\n  cursor: pointer;\n}\n\n.so-num {\n  font-variant-numeric: tabular-nums;\n}\n\n/* Mobile — visibility toggled by global .order_history_mobile_view / .desktop_view2 in style.css */\n.so-mobile {\n  padding: 0px;\n}\n\n.so-mobile__title {\n  margin: 0 0 20px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #fff;\n}\n\nbody.light_theme .so-mobile__title {\n  color: #101828;\n}\n\n.so-mobile__toolbar {\n  margin: 10px 0px;\n}\n\n.so-subtabsWrap {\n  position: relative;\n}\n\n.so-subtabs {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding: 10px 0 0;\n  margin: 0 0 14px;\n  border-bottom: none;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.so-subtabs::-webkit-scrollbar {\n  display: none;\n}\n\n.so-subtabs__tab {\n  position: relative;\n  padding: 10px 0 7px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #b5b5b6 !important;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n\nbody.light_theme .so-subtabs__tab {\n  color: #667085 !important;\n}\n\n.so-subtabs__tab:hover {\n  color: #f1f1f1;\n}\n\nbody.light_theme .so-subtabs__tab:hover {\n  color: #101828 !important;\n}\n\n.so-subtabs__tab.is-active {\n  color: #f1f1f1 !important;\n}\n\nbody.light_theme .so-subtabs__tab.is-active {\n  color: #101828 !important;\n}\n\n.so-subtabs__tab.is-active::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n  right: 0px;\n  width: 18px;\n  height: 4px;\n  background: #d1aa67;\n  border-radius: 0px;\n  margin: 0 auto;\n}\n\n/* Subtabs scroll arrows (mobile only) */\n.so-subtabsArrow {\n  display: none;\n}\n\n.so-mobileFiltersBar {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.so-filterIconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0px;\n  padding: 0px;\n  border: none;\n  background: none;\n  color: #f7f7f7;\n}\n\nbody.light_theme .so-filterIconBtn {\n  color: #101828;\n}\n\n.so-filterIconBtn i {\n  font-size: 20px;\n}\n\n.so-filtersModal .modal-body .so-toolbar {\n  margin: 0;\n}\n\n.so-filtersModal--filters .so-toolbar__right {\n  display: none !important;\n}\n\n.so-filtersModal .modal-body .so-toolbar__left {\n  width: 100%;\n}\n\n.so-filtersModal .modal-body .so-dlBtn {\n  width: 100%;\n  justify-content: center;\n}\n\n.so-filtersModal__footer {\n  display: flex;\n  gap: 10px;\n}\n\n.so-filtersModal__footer .btn {\n  flex: 1 1 0%;\n}\n\nbody.light_theme .so-filtersModal .modal-content {\n  background: rgb(255 255 255 / 20%);\n  color: #101828;\n}\n\n.so-filtersModal .modal-content {\n  background: #1e232985;\n  color: #eaecef;\n}\n\nbody.light_theme .so-filtersModal .modal-header {\n  border-bottom-color: #eef2f6;\n}\n\n.so-filtersModal .modal-header {\n  border-bottom-color: #2b3139;\n}\n\nbody.light_theme .so-filtersModal .modal-title {\n  color: #101828;\n}\n\n.so-filtersModal .modal-title {\n  color: #eaecef;\n}\n\n.so-mobileCard {\n  margin-bottom: 24px;\n}\n\n.so-mobileCard__row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 5px 0;\n  font-size: 16px;\n  color: #000;\n}\n\n.so-mobileCard__row span:first-child {\n  color: #000000;\n  font-weight: 400;\n}\n\n.so-mobileCard__row span:last-child {\n  text-align: right;\n}\n\n.so-mobileCard__actions {\n  margin-top: 0px;\n  padding-top: 0px;\n  text-align: center;\n}\n\n.so-emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-height: 400px;\n  padding: 16px 0;\n}\n\n.so-emptyState--mobile {\n  min-height: 400px;\n  margin-top: 8px;\n  padding: 32px 16px 48px;\n  border-radius: 12px;\n}\n\n.so-emptyState__img {\n  display: block;\n  width: 120px;\n  height: auto;\n  max-height: 160px;\n  object-fit: contain;\n  filter: invert(1);\n}\n\nbody.light_theme .so-emptyState__img {\n  filter: invert(0);\n}\n\n.so-emptyState__caption {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #98a2b3;\n}\n\n@media (max-width: 1440px) {\n\n  .so-toolbar .so-toolbar__left {\n    width: 70%;\n    overflow: scroll;\n  }\n\n  .listing_left_outer.full_width.transaction_history_t .so-contractCell__symbol {\n    font-size: 12px;\n  }\n\n  .listing_left_outer.full_width.transaction_history_t .so-contractCell__time {\n    font-size: 12px;\n  }\n\n  body .so-table tbody td {\n    padding: 10px;\n    font-size: 12px;\n  }\n\n  .so-side--buy {\n    font-size: 12px;\n  }\n\n  .so-side--sell {\n    font-size: 12px;\n  }\n\n  .so-toolbar__left.fullwidthdesktop {\n    width: 100%;\n  }\n\n}\n\n\n@media (max-width: 1367px) {\n\n  .so-dateCell__text {\n    font-size: 12px;\n  }\n\n  .so-dd__trigger {\n    font-size: 12px;\n  }\n\n  .so-dateBlock__label {\n    font-size: 12px;\n  }\n\n  .so-dd__label {\n    font-size: 12px;\n  }\n\n  .so-toolbar__left {\n    gap: 15px;\n  }\n\n  .so-badge--closed {\n    font-size: 12px;\n  }\n\n}\n\n@media (max-width: 1200px) {\n\n  .so-toolbar--stack .so-toolbar__left,\n  .so-toolbar--stack .so-toolbar__right {\n    flex-wrap: wrap;\n  }\n\n  body .so-table tbody td {\n    font-size: 12px;\n  }\n\n  .so-toolbar__left {\n    gap: 12px;\n  }\n\n  .so-toolbar .so-toolbar__left {\n    width: 100%;\n  }\n\n}\n\n@media (max-width: 991px) {\n\n  .so-mobile__title {\n    display: none;\n  }\n\n  .orders-mrp__panel.orders-mrp__panel--light .so-mobileCard__statusLabel {\n    font-size: 14px;\n    color: #707a8a;\n  }\n\n  .orders-mrp__panel.orders-mrp__panel--light .so-cancelBtn {\n    font-size: 14px;\n  }\n\n  .so-mobile .so-subtabs {\n    padding: 0px 0 0;\n    margin: 0 0 10px;\n    border-bottom: none;\n  }\n\n  .so-mobile .so-subtabsWrap {\n    padding: 0px;\n    /* room for arrows */\n  }\n\n  .so-dd__menu--inline {\n    position: absolute;\n    top: 64px;\n  }\n\n  .so-mobile .so-subtabsArrow {\n    display: inline-flex;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    align-items: center;\n    justify-content: center;\n    padding: 0px;\n    height: 24px;\n    border: none;\n    border-radius: 0px !important;\n    background: none;\n    color: #ffffff;\n    border-radius: 999px;\n  }\n\n  body.light_theme .so-mobile .so-subtabsArrow {\n    background: #fff;\n    color: #101828;\n  }\n\n  .so-mobile .so-subtabsArrow i {\n    font-size: 18px;\n    line-height: 1;\n  }\n\n  .so-mobile .so-subtabsArrow--left {\n    left: -17px;\n  }\n\n  .so-mobile .so-subtabsArrow--right {\n    right: -17px;\n  }\n\n  .so-mobile .so-subtabsArrow.is-hidden {\n    display: none;\n  }\n\n  .so-mobile {\n    margin-top: -12px;\n  }\n\n  .so-dd__menu--inline {\n    margin-top: 0px;\n  }\n\n}\n\n@media (max-width: 640px) {\n  .so-page {\n    padding: 20px 16px 32px;\n  }\n\n  .so-page__title {\n    font-size: 26px;\n  }\n\n  .so-toolbar:not(.so-toolbar--stack) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__left,\n  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__right {\n    width: 100%;\n  }\n\n  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__right {\n    justify-content: flex-start;\n  }\n\n  .so-dd,\n  .so-dateBlock {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .so-subtabs__tab {\n    font-size: 15px;\n  }\n\n  .so-dd__trigger {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .so-toolbar--stack .so-goStakingBtn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/*\n * Profile `/user_profile/orders/spot_*`: global style.css switches table vs cards at 1367px\n * viewport, while the profile rail uses 992px — narrow desktop can hide both or show the wrong\n * column. Force open-orders / order-history / trade-history mobile cards at ≤991px so the\n * same React `rows` as the table are visible on phones.\n */\n@media (max-width: 991.98px) {\n  .dashboard_right .dashboard_listing_section2.Overview_mid .listing_left_outer.full_width.transaction_history_t.desktop_view2.so-desktopWrap {\n    display: none !important;\n  }\n\n  .dashboard_right .dashboard_listing_section2.Overview_mid .order_history_mobile_view.so-mobile {\n    display: block !important;\n    width: 100%;\n  }\n}\n\n\n/* ========== MOBILE ROW POPUP (orderMobileRowPopup.css) ========== */\n\n/* Shared mobile row popup — popup when table has more than 6 columns / field rows; ≤6 no popup */\n\n.orders-mrp-card {\n  overflow: hidden;\n}\n\n/* Mobile order cards — white panel, pair + side/type hero, KV rows */\n.orders-mobCard {\n  color: #f0f0f0;\n  border-radius: 0px;\n  overflow: hidden;\n  margin-bottom: 12px;\n  box-shadow: none;\n  padding: 0px;\n}\n\nbody.light_theme .orders-mobCard {\n  color: #1e2329;\n}\n\n.so-mobileCard {\n  /* border-bottom: 1px solid #efefef;\n  padding-bottom: 8px; */\n}\n\n.orders-mobCard__hero {\n  padding: 5px 0 0px;\n  /* border-bottom: 1px solid #f0f2f5; */\n  margin-bottom: 2px;\n}\n\n.orders-mobCard__pairLine {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.orders-mobCard__pair {\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  letter-spacing: -0.02em;\n}\n\nbody.light_theme .orders-mobCard__pair {\n  color: #0b0e11;\n}\n\n.orders-mobCard__chev {\n  font-size: 18px;\n  color: #b7bdc6;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.orders-mobCard__datetime {\n  margin-top: 4px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.35;\n  color: #707a8a;\n}\n\n.orders-mobCard__subtypeRow {\n  margin-top: 2px;\n}\n\n.orders-mobCard__subtype {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.35;\n}\n\n.orders-mobCard__subtype--buy {\n  color: #0ecb81;\n}\n\n.orders-mobCard__subtype--sell {\n  color: #f6465d;\n}\n\n.orders-mobCard__body--plain .so-mobileCard__row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 5px 0;\n  font-size: 13px;\n  border-bottom: none;\n}\n\nul.so-dd__menu.so-dd__menu--tiles {\n  left: 0px;\n}\n\n.orders-mobCard__body--plain .so-mobileCard__row span:first-child {\n  color: #adb0b5;\n  font-weight: 400;\n  flex-shrink: 0;\n}\n\nbody.light_theme .orders-mobCard__body--plain .so-mobileCard__row span:first-child {\n  color: #707a8a;\n}\n\n.orders-mobCard__body--plain .so-mobileCard__row span:last-child {\n  text-align: right;\n  color: #e5e5e5;\n  flex-direction: row;\n}\n\nbody.light_theme .orders-mobCard__body--plain .so-mobileCard__row span:last-child {\n  color: #1e2329;\n}\n\n/* Tap hero + preview rows to open full detail sheet (when 7+ cols & 7+ rows). */\n.orders-mobCard__tapZone {\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.orders-mobCard__tapZone:focus-visible {\n  outline: 2px solid #f0b90b;\n  outline-offset: 2px;\n  border-radius: 8px;\n}\n\n.orders-mobCard__statusVal {\n  color: #98a2b3 !important;\n}\n\n.orders-mobCard .so-mobileCard__actions {\n  margin-top: 0px;\n  padding-top: 2px;\n}\n\n.orders-mrp {\n  position: fixed;\n  inset: 0;\n  z-index: 999999999;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  padding: 0px;\n  /* border-radius: 0px; */\n  padding-bottom: 0px;\n  box-sizing: border-box;\n}\n\n.orders-mrp__backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  background: rgba(0, 0, 0, 0.45);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.orders-mrp__panel {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 100%;\n  min-height: 100%;\n  max-height: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);\n  animation: orders-mrp-pop 0.2s ease-out;\n}\n\n.orders-mrp__panel--light {\n  background: #000000;\n  color: #ebebeb;\n}\n\nbody.light_theme .orders-mrp__panel--light {\n  background: #ffffff;\n  color: #1e2329;\n}\n\n@keyframes orders-mrp-pop {\n  from {\n    transform: scale(0.96);\n    opacity: 0;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.orders-mrp__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  padding: 16px 16px 5px;\n}\n\n.orders-mrp__title {\n  font-size: 17px;\n  font-weight: 600;\n  padding-right: 8px;\n}\n\n.orders-mrp__close {\n  width: 36px;\n  height: 36px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  position: relative;\n  flex-shrink: 0;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.orders-mrp__close::before,\n.orders-mrp__close::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 20px;\n  height: 2px;\n  background: #ebebeb;\n  border-radius: 1px;\n}\n\nbody.light_theme .orders-mrp__close::before,\nbody.light_theme .orders-mrp__close::after {\n  background: #454647;\n}\n\n.orders-mrp__close::before {\n  transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.orders-mrp__close::after {\n  transform: translate(-50%, -50%) rotate(-45deg);\n}\n\n.orders-mrp__body {\n  flex: 1 1 0;\n  min-height: 0;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.orders-mrp__detailInner {\n  padding: 8px 16px 4px;\n}\n\n/* Light modal: hero + rows match card */\n.orders-mrp__panel--light .orders-mrp__detailInner .orders-mobCard__hero {\n  padding-top: 4px;\n}\n\n.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row {\n  border-color: transparent;\n  font-size: 14px;\n}\n\n.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:first-child {\n  color: #707a8a;\n}\n\n.orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:last-child {\n  color: #e0e0e0;\n}\n\nbody.light_theme .orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row span:last-child {\n  color: #1e2329;\n}\n\n.orders-mrp__actionsSlot {\n  padding: 0px 16px 0px;\n}\n\n.orders-mrp__actionsSlot .so-mobileCard__actions {\n  margin: 0;\n}\n\n.orders-mrp__footer {\n  flex-shrink: 0;\n  margin-top: auto;\n  padding: 16px 16px 12px;\n  padding-bottom: max(16px, env(safe-area-inset-bottom));\n  background: #000000;\n}\n\nbody.light_theme .orders-mrp__footer {\n  background: #ffffff;\n}\n\n.orders-mrp__ok {\n  display: block;\n  width: 100%;\n  padding: 11px 16px;\n  margin: 0;\n  border: none;\n  border-radius: 50px;\n  background: #111827;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.orders-mrp__ok:focus-visible {\n  outline: 2px solid #1e2329;\n  outline-offset: 2px;\n}\n\n.orders-mrp__ok:active {\n  filter: brightness(0.95);\n}\n\n\nul.so-dd__menu.so-dd__menu--tiles {\n  flex-wrap: nowrap;\n}\n\n\n@media screen and (max-width: 767px) {\n\n  .orders-mrp__ok {\n    padding: 9px 16px;\n    font-size: 12px;\n  }\n\n  .so-status--completed {\n    font-size: 14px;\n  }\n\n\n  .so-subtabs__tab {\n    font-size: 14px;\n  }\n\n}\n\n@media screen and (max-width: 480px) {\n\n  .so-dateCell {\n    width: 100px;\n  }\n\n  .so-status--completed {\n    font-size: 13px;\n  }\n\n  .orders-mrp__panel--light .orders-mrp__detailInner .so-mobileCard__row {\n    font-size: 13px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
